import type { MouseEventHandler } from 'react';
import {
  useDateFormatPreference,
  useScanService,
  useTimeFormatPreference,
} from '@witmetrics/data-store';
import { formatDateWithTime } from '@witmetrics/utils/time';
import { getServiceCaseTypeId } from '@witmetrics/unison-core';
import CaseTypeIcon from '@/components/CaseTypeIcon';
import { CloseIcon } from '@/icons';
import Card from '@/components/Card';
import ScanServiceStatusChip from '@/components/ScanServiceStatusChip';
import IconButton from '@/components/IconButton';
import { classes } from './utils';

export type ScanServiceToasterProps = {
  serviceId: number;
  onOpen: (serviceId: number) => void;
  onClose: () => void;
};

export default function ScanServiceToaster({
  serviceId,
  onOpen,
  onClose,
}: ScanServiceToasterProps) {
  const service = useScanService(serviceId);
  const dateFormat = useDateFormatPreference();
  const timeFormat = useTimeFormatPreference();

  const handleOpen: MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onOpen(serviceId);
  };

  if (!service) return null;

  return (
    <Card className={classes.card}>
      <CaseTypeIcon
        className={classes.icon}
        projectTypeId={getServiceCaseTypeId(service.type)}
      />
      <div className={classes.content}>
        <div className={classes.title}>
          <button className={classes.name} onClick={handleOpen}>
            {service.name}
          </button>
          <IconButton className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={classes.description}>
          <p>{formatDateWithTime(service.updatedAt, dateFormat, timeFormat)}</p>
          <ScanServiceStatusChip status={service.status} />
        </div>
      </div>
    </Card>
  );
}
